import { useForm } from "react-hook-form";
import { BoxInner, ErrMsg } from "../../../style/contents/backup/backup";
import { fetchNewUserRegist } from "../../../api/admin";
import { formatPhoneNumber } from "../../../util/util";

interface ModalProps {
  closedHandler: () => void;
  onRegistSuccess: () => void; // ✅ 새로 추가
}

const RegistModal = ({ closedHandler, onRegistSuccess }: ModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      userAccount: "", // 아이디 (영문+숫자만 허용, 직접 입력 필요)
      password: "", // 비밀번호 (정규식 조건에 맞게 입력해야 함)
      confirmPassword: "", // 비밀번호 확인
      userName: "", // 이름
      department: "", // 부서
      jobPosition: "", // 직위
      userEmail: "", // 이메일
      phoneNumber: "", // 전화번호
      role: "user", // ✅ 기본 권한은 사용자
    },
  });

  const companyCode = localStorage.getItem("companyCode");

  const onSubmit = async (data: any) => {
    try {
      if (!companyCode) {
        alert("회사 코드가 없습니다. 다시 로그인해 주세요.");
        return;
      }

      // 비밀번호 확인 검증
      if (data.password !== data.confirmPassword) {
        alert("비밀번호와 비밀번호 확인이 일치하지 않습니다.");
        return;
      }

      console.log(data);

      // API에 맞게 매핑
      const params = {
        companyCode,
        userAccount: data.userAccount,
        password: data.password,
        username: data.userName,
        department: data.department ?? "",
        jobPosition: data.jobPosition ?? "",
        userEmail: data.userEmail ?? "", // ✅ 이메일 필드 추가 필요 시
        phoneNumber: data.phoneNumber ?? "", // ✅ 전화번호 필드 추가 필요 시
      };

      console.log(params);

      const res = await fetchNewUserRegist(params); // ✅ 새로운 API 호출
      console.log("✅ 등록 성공:", res);

      alert("구성원이 성공적으로 등록되었습니다.");
      reset();
      closedHandler();
      onRegistSuccess(); // ✅ 테이블 새로고침
    } catch (error) {
      console.error("❌ 등록 실패:", error);
      alert("구성원 등록에 실패했습니다.");
    }
  };

  const onError = (err: any) => {
    console.log("❌ Validation Error:", err);
    // 배포시 삭제
  };

  return (
    <BoxInner>
      <div className="modal-header">
        <p>구성원 추가</p>
        <button onClick={closedHandler} className="closed-modal-btn">
          <img src="/assets/Close_Icons_UIA.svg" alt="" />
        </button>
      </div>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className="info">
          <p>구성원 정보 입력</p>
          <span>
            <b>*</b>필수 항목
          </span>
        </div>
        <table>
          <tbody>
            <tr>
              <th>회사 코드</th>
              <td>
                <input
                  type="text"
                  readOnly
                  value={companyCode ?? ""}
                  className="read-only"
                />
              </td>
            </tr>
            <tr>
              <th>
                아이디<b>*</b>
              </th>
              <td>
                <input
                  type="text"
                  placeholder="아이디를 입력하세요."
                  {...register("userAccount", {
                    required: "아이디는 필수 입력입니다.",
                    pattern: {
                      value: /^[A-Za-z0-9]+$/,
                      message: "아이디는 영문과 숫자만 입력 가능합니다.",
                    },
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>
                비밀번호<b>*</b>
              </th>
              <td>
                <input
                  type="password"
                  placeholder="비밀번호를 입력하세요."
                  {...register("password", {
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+={}:;"'<>,.?/-]).{10,}$/,
                      message:
                        "비밀번호는 최소 10자 이상, 소문자, 숫자, 특수기호가 포함되어야 합니다.",
                    },
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>
                비밀번호 확인<b>*</b>
              </th>
              <td>
                <input
                  type="password"
                  placeholder="비밀번호를 다시 입력하세요."
                  {...register("confirmPassword", {
                    validate: (value) =>
                      value === watch("password") ||
                      "비밀번호가 일치하지 않습니다",
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>
                이름<b>*</b>
              </th>
              <td>
                <input
                  type="text"
                  placeholder="이름을 입력하세요."
                  {...register("userName", {
                    required: "이름은 필수 입력입니다.",
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>
                부서명<b>*</b>
              </th>
              <td>
                <input
                  type="text"
                  placeholder="부서를 입력하세요."
                  {...register("department", {
                    required: "부서는 필수 입력입니다.",
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>직위</th>
              <td>
                <input
                  type="text"
                  placeholder="직위 또는 직급"
                  {...register("jobPosition")}
                />
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td>
                <input
                  type="email"
                  placeholder="abcd@mail.com"
                  {...register("userEmail")}
                />
              </td>
            </tr>
            <tr>
              <th>전화번호</th>
              <td>
                <input
                  type="text"
                  maxLength={13}
                  placeholder="010-1234-5678"
                  {...register("phoneNumber")}
                  onChange={(e) => {
                    e.target.value = formatPhoneNumber(e.target.value);
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>
                권한<b>*</b>
              </th>
              <td>
                <div className="radio-box">
                  <div className="radio">
                    <input
                      type="radio"
                      id="user-radio"
                      value="user"
                      {...register("role", { required: true })}
                    />
                    <label htmlFor="user-radio">사용자</label>
                  </div>
                  <div className="radio">
                    <input
                      type="radio"
                      id="admin-radio"
                      value="admin"
                      {...register("role", { required: true })}
                    />
                    <label htmlFor="admin-radio">관리자</label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* 에러 메시지 영역 - 한 번에 하나씩만 표시 */}
        {errors.userAccount ? (
          <ErrMsg>{errors.userAccount.message as string}</ErrMsg>
        ) : errors.password ? (
          <ErrMsg>{errors.password.message as string}</ErrMsg>
        ) : errors.userName ? (
          <ErrMsg>{errors.userName.message as string}</ErrMsg>
        ) : errors.department ? (
          <ErrMsg>{errors.department.message as string}</ErrMsg>
        ) : errors.confirmPassword ? (
          <ErrMsg>{errors.confirmPassword.message as string}</ErrMsg>
        ) : null}

        <div className="btn-box">
          <button type="submit" className="regist">
            등록
          </button>
          <button type="button" className="cancel" onClick={closedHandler}>
            취소
          </button>
        </div>
      </form>
    </BoxInner>
  );
};

export default RegistModal;
